import type { AbSegment } from '@/types/nav-types'

// Both nav-topbar tests are currently pinned to their A/B winners (both segments resolve to the same
// key). To run a new test, put two distinct keys back on a line — the binary a/b plumbing stays wired.
const tests = {
  'nav-topbar-desktop': ['ab.viewTop10', 'ab.viewTop10'], // winner: View Top 10 (~1.99% CTR, best of 9)
  'nav-topbar-mobile': ['ab.topPicks', 'ab.topPicks'], // winner: Top Picks (beat Best Now)
} as const

type TestKey = keyof typeof tests

export const abTranslationKey = ({ test, segment }: { test: TestKey; segment: AbSegment }) => {
  return tests[test][segment === 'a' ? 0 : 1]
}
